import { User, UserTypeEnum } from '@jooxter/api';
import {
  ANALYTICS_ROUTE,
  BOOKINGS_MINE_ROUTE,
  HOME_ROUTE,
  MANAGE_SPACES_ROUTE,
  SEARCH_SPACE_ROUTE,
  USER_PLANNING_ROUTE,
} from '@jooxter/core';
import { IJxtRoute } from '@jooxter/ui';
import { isTeams } from '@jooxter/utils';
// eslint-disable-next-line import/named
import { TFunction } from 'i18next';
import { getEnvVar } from '@jooxter/env';
import { IUserUIPermissions } from '@jooxter/permissions';

const isDevOrStaging = getEnvVar('ENV_NAME') === 'staging';

export const showLogout = isDevOrStaging || !isTeams();
export const showAdmin = (user: User) =>
  user?.type && [UserTypeEnum.Admin, UserTypeEnum.Manager].includes(user.type) && !isTeams();
export const showManageMySpaces = (user: User) =>
  user.capabilities?.features?.resourceManager || user.capabilities?.features?.locationManager;
// The new home is booking-focused (ND-6444): without it (no booking capability, OmniVision users: ND-6510),
// users land on Spaces.
export const getLandingRoute = (home: boolean): string => (home ? HOME_ROUTE : SEARCH_SPACE_ROUTE);

export const helpCenterItem = (t: TFunction<'translation', undefined, 'translation'>): IJxtRoute => ({
  name: t('navbar.help'),
  to: t<string>('help-center-url'),
  icon: 'question-circle',
  openInNewTab: true,
});

export const manageSpacesItem = (t: TFunction<'translation', undefined, 'translation'>): IJxtRoute => ({
  name: t('navbar.manage-my-spaces'),
  to: MANAGE_SPACES_ROUTE,
  icon: 'cube',
});

export const adminItem = (t: TFunction<'translation', undefined, 'translation'>): IJxtRoute => ({
  name: t('navigation.administration-page-name'),
  to: getEnvVar('ADMIN_URL'),
  icon: 'cog',
});

export const getMainNav = (
  config: IUserUIPermissions,
  t: TFunction<'translation', undefined, 'translation'>
): IJxtRoute[] => {
  const {
    collaborators,
    navbar: { analytics, home },
    booking,
  } = config;
  const routes: IJxtRoute[] = [
    {
      name: t('navbar.spaces'),
      to: SEARCH_SPACE_ROUTE,
      icon: 'building',
    },
  ];

  // Home with the booking capability only (ND-6444), not for OmniVision users (ND-6510); collaborators only adds
  // presence and favorites to it.
  if (home) {
    routes.unshift({
      name: t('navbar.home'),
      to: HOME_ROUTE,
      icon: 'home',
    });
  }

  if (booking) {
    routes.push({
      name: t('navbar.my-bookings'),
      to: BOOKINGS_MINE_ROUTE,
      icon: 'clock',
    });
  }

  if (collaborators) {
    routes.push({
      name: t('navbar.colleagues'),
      to: USER_PLANNING_ROUTE,
      icon: 'users',
    });
  }

  if (analytics) {
    routes.push({
      name: t('navbar.analytics'),
      to: ANALYTICS_ROUTE,
      icon: 'chart-simple',
    });
  }

  return routes;
};
